import React from 'react';
import { Drawer, Typography, Button, Space, Divider } from 'antd';
import { CheckOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useInAppNotifications } from '../hooks/useInAppNotifications';
import { NotificationList } from './NotificationList';

const { Title } = Typography;

interface Props {
    visible: boolean;
    onClose: () => void;
}

export const NotificationDrawer: React.FC<Props> = ({ visible, onClose }) => {
    const navigate = useNavigate();
    const { notifications, stats, isLoading, markAllAsRead, isMarkingAllAsRead } = useInAppNotifications();

    const handleViewAll = () => { navigate('/notifications'); onClose(); };

    return (
        <Drawer
            title={
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Title level={4} style={{ margin: 0 }}>Notifications</Title>
                    <Space>
                        {stats && stats.unreadCount > 0 && (
                            <Button type="text" size="small" icon={<CheckOutlined />}
                                onClick={markAllAsRead} loading={isMarkingAllAsRead}>
                                Mark all read
                            </Button>
                        )}
                        <Button type="text" size="small" icon={<SettingOutlined />} onClick={handleViewAll}>
                            View all
                        </Button>
                    </Space>
                </div>
            }
            placement="right"
            onClose={onClose}
            open={visible}
            width={400}
        >
            {stats && (
                <div style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 6 }}>
                    <Space split={<Divider type="vertical" />}>
                        <span>Total: {stats.totalCount}</span>
                        <span>Unread: {stats.unreadCount}</span>
                    </Space>
                </div>
            )}
            <NotificationList
                notifications={notifications.slice(0, 10)}
                loading={isLoading}
                showPagination={false}
                onNotificationClick={(n) => { navigate(`/notifications/${n.id}`); onClose(); }}
            />
            {notifications.length > 10 && (
                <div style={{ textAlign: 'center', marginTop: 16 }}>
                    <Button type="link" onClick={handleViewAll}>View all {stats?.totalCount} notifications</Button>
                </div>
            )}
        </Drawer>
    );
};
